import { ALargeSmall } from "lucide-react";
import { useTextSize } from "@/context/TextSizeContext";

export function TextSizeToggle({ className = "" }) {
  const { big, toggle } = useTextSize();
  return (
    <button
      onClick={toggle}
      data-testid="text-size-toggle"
      aria-pressed={big}
      title={big ? "Riduci il testo" : "Ingrandisci il testo"}
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition-colors ${big ?"border-[#D4AF37] bg-[#D4AF37] text-[#09090B]" : "border-[#D4AF37]/40 text-[#D4AF37]"} ${className}`}
    >
      <ALargeSmall size={16} />
      <span className="hidden min-[370px]:inline">{big ? "Riduci" : "Ingrandisci"}</span>
    </button>
  );
}
